import { Component, inject, OnInit, signal } from '@angular/core';
import { ButtonGroupData } from '@shared/interfaces/button-group-data.interface';
import { TableConfig, TableData } from '@core/interfaces/table.interface';
import { TableDataService } from '@core/services/table-data.service';
import { ModalService } from '@modules/cotizaciones/services/modal-service';
import { SharedModule } from '@shared/shared.module';
import { CommonModule } from '@angular/common';
import { MultiDynamicTable } from '@shared/components/atomics/so-multi-dynamic-table/dynamic-table.component';
import { ModalConversationsComponent } from './components/modal-conversations/modal-conversations.component';
import { DashboardWhatsappService } from './service/dashboard-whatsapp.service';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import {
  AlertType,
  DynamicComponentService,
} from '@shared/components/atomics/body-loading/dynamic-component-service.service';
import { TranslateService } from '@ngx-translate/core';
import { ReplacePlaceholdersPipe } from '@core/pipes/replacePlaceholders.pipe';

@Component({
  selector: 'app-dashboard-whatsapp',
  standalone: true,
  imports: [
    SharedModule,
    CommonModule,
    MultiDynamicTable,
    ModalConversationsComponent,
    ReplacePlaceholdersPipe,
  ],
  templateUrl: './dashboard-whatsapp.component.html',
  styleUrls: ['./dashboard-whatsapp.component.scss'],
})
export class DashboardWhatsappComponent implements OnInit {
  private modalService = inject(ModalService);
  private dashboardWhatsService = inject(DashboardWhatsappService);
  private dynamicComponentService = inject(DynamicComponentService);
  private readonly translateService = inject(TranslateService);

  formFilters!: FormGroup;
  filtersActive: boolean = false;
  totalConversaciones: number = 0;
  totalMesajes: number = 0;
  sinRegistrar: any;
  titleModal = '';
  StatusMesajes = signal<any[]>([]);
  filter: boolean = false;
  conversationsUnanswered: any[] = [0, 0];
  conversationsWithoutClient: any[] = [0, 0];
  dashboard_ws_Indicators = [
    {
      title: 'conversations',
      value: '15',
      icon: 'chat-config',
    },
    {
      title: 'messages',
      value: '45',
      icon: 'mdi-3p',
    },
    {
      key: 'SnProspect',
      title: 'ConvSinProspecto',
      value: '45',
      icon: 'mdi-3p',
    },
    {
      key: 'Cartera',
      title: 'portfolio_conversations',
      value: '15',
      icon: 'mdi-comment-bank',
    },
    {
      key: 'SinRespuesta',
      title: 'unanswered_conversations',
      value: '9',
      icon: 'mdi-sms-failed',
    },
    {
      key: 'SinRespuestaCliente',
      title: 'client_unanswered_conversations',
      value: '4',
      icon: 'mdi-sms',
    },
  ];

  filters: any[] = [
    {
      title: 'current_month',
      selected: true,
    },
    {
      title: 'by_period',
      selected: false,
    },
  ];

  tableConfig!: TableConfig;
  data!: TableData[];
  dataModal: any;
  loading = false;
  queryParams: any;
  showConversaciones = true;
  inicio!: any;
  fin!: any;
  columns: any[] = [];

  activar(event: ButtonGroupData) {
    this.filtersActive = event.title === 'by_period';
    this.inicio = this.formFilters.get('inicio');
    this.fin = this.formFilters.get('fin');
    this.getInfo();
  }

  constructor(
    private tableDataService: TableDataService,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    const formatoISO = this.getTodayDate();
    this.formFilters = this.fb.group({
      inicio: [formatoISO],
      fin: [formatoISO],
    });
  }

  ngOnInit(): void {
    this.getInfo();
  }

  onButtonClick(event: { action: string; data: any }) {
    if (event.data['idEjecutivo']) {
      const indicador = {
        title: 'conversations',
        value: '',
        key: 'Ejecutivo',
        idEjecutivo: event.data['idEjecutivo'],
        icon: 'chat-config',
      };
      this.getInfoDetail(indicador);
    } else {
      this.dataModal = this.sinRegistrar;
      this.modalService.openModal('modal-conversations-wts');
    }
  }

  onLinkClick(event: { data: any }) {}

  toggleTableData() {
    this.showConversaciones = !this.showConversaciones;
    this.tableConfig = this.showConversaciones
      ? this.tableDataService.getSampleTableConfig()
      : this.tableDataService.getEtapasTableConfig();
  }

  openModal(indicador: any) {
    const filter = indicador.key;
    if (filter && filter !== 'SnProspect') {
      this.getInfoDetail(indicador);
    } else {
      this.dataModal = this.sinRegistrar;
      this.modalService.openModal('modal-conversations-wts');
    }
  }

  adminDataDashboard(data: any) {
    this.columns = this.getColumnsEjecutivos();
    const dataEjecutivos = data.ejecutivos;
    this.data = dataEjecutivos.sort((a: any, b: any) =>
      a.Ejecutivo.localeCompare(b.Ejecutivo)
    );
    this.totalConversaciones = data.totals.Conversaciones;
    this.conversationsUnanswered = [
      data.totals.ConvSinRespuesta,
      data.totals.Conversaciones,
    ];
    this.conversationsWithoutClient = [
      data.totals.ConvSinRespuestaCliente,
      data.totals.Conversaciones,
    ];
    this.StatusMesajes.set(data.status);
    this.totalMesajes = data.totals.Mensajes;
    console.log(data.totals);

    this.dashboard_ws_Indicators[0].value = data.totals.Conversaciones;
    this.dashboard_ws_Indicators[1].value = data.totals.Mensajes;
    this.dashboard_ws_Indicators[2].value = data.totals.ConvSinProspecto;
    this.dashboard_ws_Indicators[3].value = data.totals.ConvCartera;
    this.dashboard_ws_Indicators[4].value = data.totals.ConvSinRespuesta;
    this.dashboard_ws_Indicators[5].value = data.totals.ConvSinRespuestaCliente;
    this.sinRegistrar = data.table.data.filter((a: any) => {
      return a.registro === 'Sin Registrar';
    });
    this.dynamicComponentService.destroyBodyLoading();
  }

  getInfo() {
    this.dynamicComponentService.showBodyLoading();
    this.queryParams = this.route.snapshot.queryParamMap;
    const today = this.getTodayDate();
    const inicio = this.formFilters.get('inicio');
    const fin = this.formFilters.get('fin');
    this.dashboardWhatsService
      .getDashboardWhats(
        this.queryParams.get('IdDistribuidor')!,
        this.queryParams.get('IdMarca')!,
        this.queryParams.get('eMail')!,
        this.queryParams.get('RegistryId')!,
        this.queryParams.get('Token')!,
        !this.filtersActive ? this.getInicioDelMes() : inicio?.value!,
        !this.filtersActive ? today : fin?.value!
      )
      .subscribe(
        (data) => {
          console.log('DATA', data);

          this.adminDataDashboard(data);
        },
        (err) => console.error(err)
      );
  }

  getInfoDetail(indidcador: any) {
    this.dynamicComponentService.showBodyLoading();
    const p = this.route.snapshot.queryParamMap;
    const today = this.getTodayDate();
    const inicio = this.formFilters.get('inicio');
    const fin = this.formFilters.get('fin');
    this.dashboardWhatsService
      .getDashboardWhatsDetails(
        p.get('IdDistribuidor')!,
        p.get('IdMarca')!,
        p.get('eMail')!,
        indidcador['idEjecutivo']
          ? indidcador['idEjecutivo']
          : p.get('RegistryId')!,
        p.get('Token')!,
        !this.filtersActive ? this.getInicioDelMes() : inicio?.value!,
        indidcador.key,
        !this.filtersActive ? today : fin?.value!,
        1
      )
      .subscribe(
        (response) => {
          this.dynamicComponentService.destroyBodyLoading();
          this.dataModal = response.table.data.sort((a: any, b: any) =>
            a.prospecto.localeCompare(b.prospecto)
          );
          this.titleModal = this.translateService.instant(indidcador.title);
          this.modalService.openModal('modal-conversations-wts');
        },
        (err) => console.error(err)
      );
  }

  applyFilters() {
    const inicio = this.formFilters.get('inicio');
    const fin = this.formFilters.get('fin');
    const dateInicio = new Date(inicio?.value);
    const dateFin = new Date(fin?.value);

    if (dateInicio.getTime() > dateFin.getTime()) {
      this.dynamicComponentService.showAlert({
        alertType: AlertType.info,
        message: 'La fecha de inicio no puede ser mayor',
        animate: true,
        autohide: true,
        showButtonClose: true,
      });
      this.inicializarFormulario();
    } else {
      this.getInfo();
    }
  }

  inicializarFormulario() {
    const date = this.getTodayDate();
    this.formFilters = this.fb.group({
      inicio: [date],
      fin: [date],
    });
    this.inicio = this.formFilters.get('inicio');
    this.fin = this.formFilters.get('fin');

    this.inicio?.markAllAsTouched();
    this.inicio?.markAsDirty();

    this.fin?.markAllAsTouched();
    this.fin?.markAsDirty();
  }

  getTodayDate() {
    const hoy = new Date();
    return hoy.toISOString().split('T')[0];
  }

  getInicioDelMes(): string {
    const hoy = new Date();
    const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);

    const year = inicioMes.getFullYear();
    const month = ('0' + (inicioMes.getMonth() + 1)).slice(-2);
    const day = ('0' + inicioMes.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  getColumnsEjecutivos() {
    return [
      {
        key: 'idEjecutivo',
        title: 'IdEjecutivo',
        isHidden: true,
        type: 'text',
        width: '250px',
        sortable: true,
        filterable: true,
      },
      {
        key: 'Ejecutivo',
        title: 'Ejecutivo',
        type: 'text',
        width: '250px',
        sortable: true,
        filterable: true,
      },
      {
        key: 'Conversaciones',
        title: 'Conversaciones',
        type: 'badge-circle',
        click: true,
        width: '100px',
        sortable: true,
        badgeConfig: {
          colorMap: {
            '1': 'so-bg-secondary',
            '0': 'so-bg-primary',
          },
        },
      },
      {
        key: 'Mensajes',
        title: 'Mensajes',
        type: 'icon',
        icon: 'message',
        width: '250px',
        sortable: true,
        filterable: true,
      },
      {
        key: 'Sin_Respuesta',
        title: 'Conv. Sin Resp',
        type: 'text',
        width: '250px',
        sortable: true,
        filterable: true,
      },
      {
        key: 'Sin_Respuesta_Cliente',
        title: 'Sin Resp. Cliente',
        type: 'text',
        width: '250px',
        sortable: true,
        filterable: true,
      },
      {
        key: 'Tiempo_Sin_Respuesta',
        title: 'Conv. Sin Resp. Cliente',
        type: 'time',
        width: '250px',
        sortable: true,
        filterable: true,
      },
      {
        key: 'Tiempo_Sin_Respuesta_Cliente',
        title: 'Tiempo Sin Resp. Cliente',
        type: 'time',
        width: '250px',
        sortable: true,
        filterable: true,
      },
    ];
  }
}
